@import '../styles/palette.scss';
@import '../styles/fonts.scss';
@import '../styles/mixins.scss';

.pagenotfound {
  text-align: center;

  .space24 {
    @include space(24);
  }

  .space65 {
    @include space(65);
  }

  button {
    @include barlow(14);
    text-transform: uppercase;
  }

  .spaceForIllustration {
    min-height: 17.5rem;
    width: 37.5rem;
  }

  .illustration {
    @include barlow(16);
    background-image: url('./ill_404_page_not_found.svg');
    background-position: top;
    background-repeat: no-repeat;
    background-size: contain;

    h1 {
      @include merriweather(48);
      color: _palette(text-primary);
      font-style: normal;
    }

    h2 {
      @include merriweather(26);
      color: _palette(text-primary);
      font-style: normal;
    }

    h3 {
      @include barlow(16);
      border-top: 1px solid _palette(text-secondary);
      color: _palette(text-secondary);
      padding: 1.5rem;
      text-align: center;
    }
  }

  .footer {
    border-top: solid 1px _palette(border-strong);
    display: inline-block;
    width: 28rem;

    a {
      @include button-style();
    }
  }
}
